<template>
  <div>
    <mainHeader></mainHeader>
    <sideMenu :studyData="studyData"></sideMenu>
    <div id="data-export-filter-container" class="has-sidemenu has-header">
      <div id="inner-container">
        <div class="back-container"><span class="fa fa-caret-left"></span>&nbsp;<a @click="$router.go(-1)" title="Back" class="link">Back</a></div>
        <div class="heading">
          {{ complianceReportData ? "Export Compliance Report" : "Export Data" }}
        </div>
        <div class="description">
          {{ complianceReportData ? "Retrieve your report by using one of the two export options below." : "Retrieve your study data by using one of the two export options below." }}
        </div>
        <div class="row mt-22">
          <!-- Export All Data Section Start -->
          <div class="col-md-4 pl-0 pr-14">
            <div class="card">
              <div class="card-header">
                {{ complianceReportData ? "Export All Compliance Data" : "Export All Data" }}
              </div>
              <div class="card-body">
                <p class="mb-29">
                  {{ complianceReportData ? "Perform a complete export of all compliance study data." : "Perform a complete export of all study data." }}
                </p>
                <div class="delimited-checkbox" :class="{ disable_ele: !isexportDataBtnDisabled }">
                  <b-form-checkbox id="checkbox-1" v-model="pipeDelimitedAllData" name="checkbox-1">
                    Pipe (|) delimited format
                  </b-form-checkbox>
                </div>
                <button type="button" class="btn btn-danger pl-25 pr-25" :class="{ disable_ele: !isexportDataBtnDisabled }" v-on:click="complianceReportData ? downloadComplianceReport() : exportParticipantData()">
                  {{ complianceReportData ? "Export All Compliance Data" : "Export All Study Data" }}
                </button>
              </div>
            </div>
          </div>
          <!-- Export All Data Section End -->

          <!-- Export Selected Data Start -->
          <div class="col-md-8 pr-0">
            <div class="card">
              <div class="card-header">
                {{ complianceReportData ? "Export Selected Compliance Data" : "Export Selected Data" }}
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="mr-auto">
                    <p>Filter your data export with the options below</p>
                  </div>
                  <div>
                    <span class="reset_btn" :class="{ reset_btn_disabled: isexportDataBtnDisabled }" @click="resetFilter()">X Reset filters</span>
                  </div>
                </div>

                <!-- Timeframe Filter Start -->
                <div class="filter-category">
                  <div class="row">
                    <div class="col-md-4">
                      <span class="category-name">{{ complianceReportData ? "Completion Timeframe" : "Timeframe" }}</span>
                    </div>
                    <div class="col-md-4">
                      <input class="form-check-input" v-model="isHiddenDate" :value="true" type="radio" @change="toggleDate(isHiddenDate)" name="dateRadioOption" />
                      <label class="form-check-label" for="inlineRadio1">All time</label>
                    </div>
                    <div class="col-md-4">
                      <input class="form-check-input" v-model="isHiddenDate" :value="false" type="radio" @change="toggleDate(isHiddenDate)" name="dateRadioOption" />
                      <label class="form-check-label" for="inlineRadio2">Select dates</label>
                    </div>
                  </div>

                  <div class="row timeframe-dates" v-if="!isHiddenDate">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="col-form-label">Start Date</label>
                        <Datepicker :calendar-button="true" v-model="startDate" @selected="onChangeEndDate()" calendar-button-icon="fa fa-calendar-o" input-class="form-control date-input" placeholder="Select"></Datepicker>
                      </div>
                    </div>

                    <div class="col-lg-6">
                      <div class="form-group end-date">
                        <label class="col-form-label">End Date</label>
                        <Datepicker :calendar-button="true" v-model="endDate" @selected="onChangeEndDate()" :highlighted="{ dates: [new Date()] }" calendar-button-icon="fa fa-calendar-o" input-class="form-control date-input" placeholder="Select"></Datepicker>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Timeframe Filter End -->

                <!-- Activities/ Folders Filter Start -->
                <div class="filter-category">
                  <div class="row">
                    <div class="col-md-4">
                      <span class="category-name">{{ complianceReportData ? "Activities" : "Folders/ Subfolders" }}</span>
                    </div>
                    <div class="col-md-4">
                      <input class="form-check-input" v-model="isHiddenFolder" :value="true" type="radio" @change="toggleFolder(isHiddenFolder)" name="folderSubFolder" />
                      <label class="form-check-label" for="inlineRadio1">{{ complianceReportData ? "All activities" : "All folders/ subfolders" }}</label>
                    </div>
                    <div class="col-md-4">
                      <input class="form-check-input" v-model="isHiddenFolder" :value="false" type="radio" @change="toggleFolder(isHiddenFolder)" name="folderSubFolder" />
                      <label class="form-check-label" for="inlineRadio2">{{ complianceReportData ? "Select activities" : "Select folders/ subfolders" }}</label>
                    </div>
                  </div>

                  <div class="study-sites" v-if="!isHiddenFolder">
                    <div class="tab tableBodyScroll">
                      <div class="row">
                        <div class="col-md-4">
                          <div v-for="(folder, index) in listFilter(folders, 0, 5)" :key="index" class="colMarginCss">
                            <div>
                              <label class="select-checkbox">
                                <input :id="folder.id" :value="folder.id" v-model="folder.checked" v-on:change="onSelectFolder(folder)" type="checkbox" />
                                <span class></span>
                              </label>
                              <span class="ml-5">{{ folder.displayText }}</span>
                              <span v-if="folder.subFolders && folder.subFolders.length > 0">
                                <span v-if="!folder.isOpen" @click="onChangeOpen(folder)" :class="{ disable_ele: !folder.checked }"><i class="fa fa-plus-square ml-5" aria-hidden="true"></i></span>
                                <span v-if="folder.isOpen" @click="onChangeOpen(folder)"><i class="fa fa-minus-square ml-5" aria-hidden="true"></i></span>
                              </span>
                              <div class="ml-18" v-if="folder.isOpen">
                                <div v-for="(subFolder, index) in folder.subFolders" :key="index">
                                  <label class="select-checkbox">
                                    <input :id="subFolder.id" :value="subFolder.id" v-model="subFolder.checked" v-on:change="onSelectSubFolder(subFolder.checked, folder)" type="checkbox" />
                                    <span class></span>
                                  </label>
                                  <span class="ml-5" v-b-popover.hover.right="subFolder.subFolderName" v-if="subFolder.subFolderName.length >= 18">{{ subFolder.subFolderName.slice(0, 17) }}..</span>
                                  <span class="ml-5" v-else>{{ subFolder.subFolderName }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-4">
                          <div v-for="(folder, index) in listFilter(folders, 5, 9)" :key="index" class="colMarginCss">
                            <div>
                              <label class="select-checkbox">
                                <input :id="folder.id" :value="folder.id" v-model="folder.checked" v-on:change="onSelectFolder(folder)" type="checkbox" />
                                <span class></span>
                              </label>
                              <span class="ml-5">{{ folder.displayText }}</span>
                              <span v-if="folder.subFolders && folder.subFolders.length > 0">
                                <span v-if="!folder.isOpen" @click="onChangeOpen(folder)" :class="{ disable_ele: !folder.checked }"><i class="fa fa-plus-square ml-5" aria-hidden="true"></i></span>
                                <span v-if="folder.isOpen" @click="onChangeOpen(folder)"><i class="fa fa-minus-square ml-5" aria-hidden="true"></i></span>
                              </span>
                              <div class="ml-18" v-if="folder.isOpen">
                                <div v-for="(subFolder, index) in folder.subFolders" :key="index">
                                  <label class="select-checkbox">
                                    <input :id="subFolder.id" :value="subFolder.id" v-model="subFolder.checked" v-on:change="onSelectSubFolder(subFolder.checked, folder)" type="checkbox" />
                                    <span class></span>
                                  </label>
                                  <span class="ml-5" v-b-popover.hover.right="subFolder.subFolderName" v-if="subFolder.subFolderName.length >= 18">{{ subFolder.subFolderName.slice(0, 17) }}..</span>
                                  <span class="ml-5" v-else>{{ subFolder.subFolderName }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-4">
                          <div v-for="(folder, index) in listFilter(folders, 9, 13)" :key="index" class="colMarginCss">
                            <div>
                              <label class="select-checkbox">
                                <input :id="folder.id" :value="folder.id" v-model="folder.checked" v-on:change="onSelectFolder(folder)" type="checkbox" />
                                <span class></span>
                              </label>
                              <span class="ml-5">{{ folder.displayText }}</span>
                              <span v-if="folder.subFolders && folder.subFolders.length > 0">
                                <span v-if="!folder.isOpen" @click="onChangeOpen(folder)" :class="{ disable_ele: !folder.checked }"><i class="fa fa-plus-square ml-5" aria-hidden="true"></i></span>
                                <span v-if="folder.isOpen" @click="onChangeOpen(folder)"><i class="fa fa-minus-square ml-5" aria-hidden="true"></i></span>
                              </span>
                              <div class="ml-18" v-if="folder.isOpen">
                                <div v-for="(subFolder, index) in folder.subFolders" :key="index">
                                  <label class="select-checkbox">
                                    <input :id="subFolder.id" :value="subFolder.id" v-model="subFolder.checked" v-on:change="onSelectSubFolder(subFolder.checked, folder)" type="checkbox" />
                                    <span class></span>
                                  </label>
                                  <span class="ml-5" v-b-popover.hover.right="subFolder.subFolderName" v-if="subFolder.subFolderName.length >= 18">{{ subFolder.subFolderName.slice(0, 17) }}..</span>
                                  <span class="ml-5" v-else>{{ subFolder.subFolderName }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Activities/ Folders Filter End -->

                <!-- Study Sites Filter Start -->
                <div class="filter-category" v-if="canSiteTeamAccess && sites.length > 1">
                  <div class="row">
                    <div class="col-md-4">
                      <span class="category-name">Study Sites</span>
                    </div>
                    <div class="col-md-4">
                      <input class="form-check-input" v-model="isHiddenSites" :value="true" type="radio" @change="toggleSites()" name="siteRadioOptions" />
                      <label class="form-check-label" for="inlineRadio1">All study sites</label>
                    </div>
                    <div class="col-md-4">
                      <input
                        class="form-check-input"
                        v-model="isHiddenSites"
                        :value="false"
                        type="radio"
                        @change="
                          toggleSites();
                          AllSelectedSites = false;
                        "
                        name="siteRadioOptions"
                      />
                      <label class="form-check-label" for="inlineRadio2">Select study sites</label>
                    </div>
                  </div>
                  <div class="study-sites" v-if="!isHiddenSites">
                    <table class="table table-sm tableBodyScroll table-hover">
                      <thead>
                        <tr>
                          <th class="w-64 text-center">
                            <label class="select-checkbox">
                              <input type="checkbox" v-model="AllSelectedSites" @input="SelectAllsites()" />
                              <span class></span>
                            </label>
                          </th>
                          <th>Site ID</th>
                          <th>Site Name</th>
                          <th>Site Country</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="site in sites" :key="site.siteId">
                          <td class="w-64 text-center">
                            <label class="select-checkbox">
                              <input :id="site.siteId" :value="site.siteId" v-model="site.checked" v-on:change="onSiteChange(site, site.checked)" type="checkbox" />
                              <span class></span>
                            </label>
                          </td>
                          <td class="">{{ site.userDefinedSiteId }}</td>
                          <td class="pl-15">{{ site.siteName }}</td>
                          <td class="pl-15">{{ site.countries }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Study Sites Filter End -->

                <!-- Participants by Country Filter Start -->
                <div class="filter-category" v-if="isShowCountries">
                  <div class="row">
                    <div class="col-md-4">
                      <span class="category-name">Participants by Country</span>
                    </div>
                    <div class="col-md-4">
                      <input class="form-check-input" v-model="isHiddenCountries" :value="true" type="radio" @change="toggleCountry(isHiddenCountries)" name="countriesRadioOptions" />
                      <label class="form-check-label" for="inlineRadio1">All countries</label>
                    </div>
                    <div class="col-md-4">
                      <input class="form-check-input" v-model="isHiddenCountries" :value="false" type="radio" @change="toggleCountry(isHiddenCountries)" name="countriesRadioOptions" />
                      <label class="form-check-label" for="inlineRadio2">Select countries</label>
                    </div>
                  </div>
                  <div class="participant-by-country" v-if="!isHiddenCountries && countries.length > 0">
                    <table class="table table-sm tableBodyScroll table-hover">
                      <thead>
                        <tr>
                          <th class="w-64 text-center">Selected</th>
                          <th class="">Country</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="country in countries" :key="country.countryId">
                          <td class="w-64 text-center">
                            <label class="select-checkbox">
                              <input :id="country.countryId" v-model="country.checked" v-on:change="onSelectCountry(country, country.checked)" :value="country.countryId" type="checkbox" />
                              <span class></span>
                            </label>
                          </td>
                          <td class="pl-15">{{ country.countryName }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Participants by Country Filter End -->

                <!-- Participants by ID Filter Start -->
                <div class="filter-category last">
                  <div class="row">
                    <div class="col-md-4">
                      <span class="category-name">Participants by ID</span>
                    </div>
                    <div class="col-md-4">
                      <input class="form-check-input" v-model="isHiddenParticipants" :value="true" type="radio" @change="toggleParticipant(isHiddenParticipants)" name="participantsRadioOptions" id="allParticipant" />
                      <label class="form-check-label" for="allParticipant">All Participants</label>
                    </div>
                    <div class="col-md-4">
                      <input class="form-check-input" v-model="isHiddenParticipants" :value="false" type="radio" @change="toggleParticipant(isHiddenParticipants)" name="participantsRadioOptions" id="selectParticipants" />
                      <label class="form-check-label" for="selectParticipants">Select Participants</label>
                    </div>
                  </div>
                  <div class="participant-by-id" v-if="!isHiddenParticipants">
                    <div class="sub-heading">
                      Search Participant ID or THREAD ID
                    </div>

                    <div class="row">
                      <div class="col-md-7 pl-0">
                        <div class="input-group mb-3">
                          <input type="text" class="form-control" v-model="searchParticipant" placeholder="Enter Participant ID or THREAD ID" />
                          <div class="input-group-append">
                            <button class="btn btn-primary" type="button" :disabled="!searchParticipant.length" @click="onParticipantSearch()">
                              <img src="static/img/loupe.png" class="search" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 pl-0">
                        <button @click="openParticipantModal" class="btn btn-outline-primary vlb btn-pad-fix" type="button">
                          View all participants
                        </button>
                      </div>
                      <div class="col-md-2 pl-0 pr-0">
                        <button v-if="participantsList && participantsList.length" class="btn btn-primary slc btn-block" type="button">{{ filteredSelectedParticipants.length }} Selected</button>
                      </div>
                    </div>
                    <div class="participants-container" v-if="participantsList && participantsList.length > 0">
                      <table class="table table-sm tableBodyScroll table-hover">
                        <thead>
                          <tr>
                            <th class="w-64 text-center">Select</th>
                            <th>Participant ID</th>
                            <th>THREAD ID</th>
                            <th v-if="canResearchSiteTeamAccess || canSiteDataLockAccess || user.readOnly">
                              Email
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="participantsList && participantsList.length > 0">
                          <tr v-for="participant in participantsList" :key="`Participant-${participant.id}`">
                            <td class="w-64 text-center">
                              <label class="select-checkbox">
                                <input :id="`sel-input-check-${participant.id}`" :value="participant" v-model="filteredSelectedParticipants" type="checkbox" />
                                <span class></span>
                              </label>
                            </td>
                            <td>{{ participant.userDefinedParticipantId }}</td>
                            <td>{{ participant.id }}</td>
                            <td v-if="canResearchSiteTeamAccess || canSiteDataLockAccess || user.readOnly">
                              {{ participant.email }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- Participants by ID Filter End -->
                <div class="delimited-checkbox" :class="{ disable_ele: isexportDataBtnDisabled }">
                  <b-form-checkbox id="checkbox-2" v-model="pipeDelimitedSelectedData" name="checkbox-2">
                    Pipe (|) delimited format
                  </b-form-checkbox>
                </div>

                <!-- Export Selected Data Button -->
                <button type="button" class="btn btn-danger" :class="{ disable_ele: isexportDataBtnDisabled }" v-on:click="exportSelectedData()">
                  {{ complianceReportData ? "Export Selected Compliance Data" : "Export Selected Data" }}
                </button>
                <!-- Export Selected Data Button -->
              </div>
            </div>
          </div>
          <!-- Export Selected Data End -->
        </div>
      </div>
    </div>

    <!-- View All Participants Modal Start -->
    <b-modal id="all-participant-modal" ref="allParticipantModal" size="lg" hide-footer :no-close-on-esc="noCloseOnBackdrop" :no-close-on-backdrop="noCloseOnBackdrop">
      <template slot="modal-title">
        View All Participants
      </template>
      <template slot="modal-header-close">
        <span @click="closeModal()"><span class="fa fa-times"></span> Close</span>
      </template>

      <div class="participants-container all-participants">
        <table class="table table-sm tableBodyScroll table-hover">
          <thead>
            <tr>
              <th class="w-64 text-center">Select</th>
              <th>Participant ID</th>
              <th>THREAD ID</th>
              <th v-if="canResearchSiteTeamAccess || canSiteDataLockAccess || user.readOnly">
                Email
              </th>
            </tr>
          </thead>
          <tbody v-if="allParticipants && allParticipants.length > 0">
            <tr v-for="(participant, index) in allParticipants" :key="`participant-${index}`">
              <td class="w-64 text-center">
                <label class="select-checkbox">
                  <input :id="`input-check-${participant.id}`" :value="participant" type="checkbox" v-model="selectedParticipantsInModal" />
                  <span class></span>
                </label>
              </td>
              <td>{{ participant.userDefinedParticipantId }}</td>
              <td>{{ participant.id }}</td>
              <td v-if="canResearchSiteTeamAccess || canSiteDataLockAccess || user.readOnly">
                {{ participant.email }}
              </td>
            </tr>
          </tbody>
          <tbody v-if="allParticipants && allParticipants.length <= 0">
            <div class="row text-center">
              <div class="fs-20 pt-150 "><b>No participant found.</b></div>
            </div>
          </tbody>
        </table>
        <div class="pagination-links">
          <div class="row">
            <div class="col-md-2">
              <span v-if="currentPage > 1" @click="prevPage()" class="back-link"> <span class="fa fa-caret-left"></span> Back </span>
            </div>
            <div class="col-md-8 pages">
              <span v-for="page in totalPages" :key="`page-no-${page}`" :class="{ active: page == currentPage ? true : false }" v-on="page != currentPage ? { click: () => goToPage(page) } : {}">{{ page }}</span>
            </div>
            <div class="col-md-2 text-right">
              <span v-if="currentPage < totalPages" @click="nextPage()" class="next-link"> Next <span class="fa fa-caret-right"></span> </span>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- View All Participants Modal End -->
  </div>
</template>

<script>
import mainHeader from "../common/main-header";
import sideMenu from "../common/side-menu";
import Datepicker from "vuejs-datepicker";
import toastr from "toastr";
import sortBy from "lodash/sortBy";
import _ from "lodash";
import moment from "moment";
import { STUDY_ADMIN, SYSTEM_ADMIN, PI, SUB_PI, STUDY_COORDINATOR, HOME_HEALTH, SITEDATALOCK, QUALITY, DM, CRA, CraUB } from "@/constants/authRoles";
import { AclRule } from "vue-acl";
import { mapGetters } from "vuex";
import localStorageService from "@/services/localStorage";
import nprogress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "data-export",
  props: ["complianceReportData"],
  data() {
    return {
      studyId: this.$route.params.studyId,
      studyData: {},
      participantsList: [],
      filteredSelectedParticipants: [],
      filters: [],
      isHiddenDate: true,
      isHiddenFolder: true,
      isHiddenSites: true,
      isHiddenCountries: true,
      isHiddenParticipants: true,
      isSubFolderChecked: true,
      startDate: "",
      endDate: "",
      countries: [],
      folders: [],
      siteCountries: [],
      sites: [],
      timeFrame: {},
      siteId: "",
      selectedCountries: [],
      selectedCountryIds: [],
      selectedSiteIds: [],
      AllSelectedSites: false,
      siteIds: "",
      countryIds: "",
      currentPage: 1,
      recordsPerPage: 15,
      totalPages: 0,
      allParticipants: [],
      showParticipentModal: false,
      noCloseOnBackdrop: true,
      selectedParticipantsInModal: [],
      selectedCountryList: [],
      selectedSiteList: [],
      searchParticipant: "",
      isShowCountries: true,
      pipeDelimitedAllData: false,
      pipeDelimitedSelectedData: false
    };
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canSystemAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canCRAAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canDMAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPIAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    canResearchSiteTeamAccess() {
      return this.canPiAccess || this.canSubPIAccess || this.canStudyCoordinatorAccess || this.canHomeHealthAccess;
    },
    canSiteTeamAccess() {
      return this.canStudyAdminAccess || this.canSystemAdminAccess || this.canQualityAccess || this.canCRAAccess || this.canDMAccess || this.canCraUBAccess;
    },
    isexportDataBtnDisabled() {
      if (this.isHiddenDate && this.isHiddenFolder && this.isHiddenSites && this.isHiddenCountries && this.isHiddenParticipants) {
        return true;
      } else {
        return false;
      }
    }
  },
  components: {
    sideMenu,
    mainHeader,
    Datepicker
  },
  created() {
    this.getStudyDetails();
  },
  mounted() {
    this.getStudyDataExportFilters();
  },
  methods: {
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(response => {
        this.studyData = response.body;
      });
    },
    exportParticipantData() {
      const pipeDelimited = this.pipeDelimitedAllData;
      this.$api.exportParticipantDashboardFact(this.studyId, "", pipeDelimited).then(response => {
        toastr.success(response.data.message);
      });
    },
    downloadComplianceReport() {
      this.$api.exportComplianceData(this.studyId).then(response => {
        toastr.success(response.bodyText);
      });
    },
    openParticipantModal() {
      this.selectedParticipantsInModal = _.cloneDeep(this.filteredSelectedParticipants);
      this.searchParticipant = [];
      //this.selectedParticipants = [];
      this.getAllParticipants();
    },
    onParticipantSelection() {
      //LETS ASSIGN THE PARTICIPANTS SELECTED THROUHG PARTICIPANTS MODAL TO OUR ACTUAL filteredSelectedParticipants ARRAY
      const participantsSelThorughModal = _.cloneDeep(this.selectedParticipantsInModal);
      this.filteredSelectedParticipants = participantsSelThorughModal;
      this.participantsList = _.unionBy(this.participantsList, participantsSelThorughModal, "id"); //REMOVE DUPLICATES
    },
    getStudyDataExportFilters() {
      const user = localStorageService.getItem("userObj");
      if (user.siteIds) {
        this.siteId = user.siteIds[0];
      } else {
        this.siteId = null;
      }
      this.$api.getStudyDataExportFilters(this.studyId, this.siteId, this.complianceReportData).then(
        response => {
          const filters = response.body.filters;
          const countries = filters.countries.map(item => ({
            ...item,
            checked: false
          }));
          this.countries = sortBy(countries, "countryName");
          this.countriesCopy = sortBy(countries, "countryName");
          this.folders = filters.folders.map(item => ({
            ...item,
            checked: false,
            isOpen: false
          }));

          if (this.countries.length === 1) {
            this.isShowCountries = false;
          }

          this.folders.forEach(item => {
            if (item.subFolders && item.subFolders.length > 0) {
              item.subFolders.forEach(x => {
                x["checked"] = false;
              });
            }
          });

          this.siteCountries = filters.siteCountries;
          const sites = filters.sites.map(item => ({
            ...item,
            checked: false
          }));
          this.sites = sortBy(sites, "userDefinedSiteId");
          this.timeFrame = filters.timeFrame;
          this.$forceUpdate();
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting study data export.");
        }
      );
    },
    listFilter(arr, start, end) {
      return arr.slice(start, end);
    },
    onChangeOpen(folder) {
      folder.isOpen = !folder.isOpen;
    },
    onSiteChange(site, checked) {
      let country = {};
      let siteCountries = [];
      siteCountries = site.countries.split(",");
      for (const key in this.siteCountries) {
        if (site.siteId == key) {
          country = this.siteCountries[key];
        }
      }

      if (checked) {
        this.selectedSiteIds.push(site.siteId);
        this.selectedSiteList.push(site);
        country.forEach(co => {
          const found = this.selectedCountries.some(item => item.countryId === co.countryId);
          if (!found) {
            this.selectedCountries.push(co);
          }
        });

        this.countries = [];
        for (const i in this.selectedCountries) {
          this.countries.push(this.selectedCountries[i]);
        }
        this.countries = this.countries.map(item => ({
          ...item,
          checked: false
        }));
      } else {
        this.selectedSiteIds = this.selectedSiteIds.filter(item => item != site.siteId);
        this.selectedSiteList = this.selectedSiteList.filter(item => item != site);
        const unCheckedSiteCountries = site.countries.split(",");
        const selectedSites = this.sites.filter(item => item.checked);
        const checkedCountries = [];
        for (const ss of selectedSites) {
          const cArr = ss.countries.split(",");
          for (const c of cArr) {
            checkedCountries.push(c);
          }
        }
        const uniqueC = [...new Set(checkedCountries)];
        if (selectedSites.length > 0) {
          unCheckedSiteCountries.forEach(uc => {
            const found = uniqueC.some(item => item === uc);
            if (!found) {
              const index = this.selectedCountries.findIndex(item => item.countryName === uc);
              this.selectedCountries.splice(index, 1);
            }
          });
        } else {
          for (const cName of siteCountries) {
            const index = this.selectedCountries.findIndex(item => item.countryName === cName);
            this.selectedCountries.splice(index, 1);
          }
        }

        this.countries = [];
        if (this.selectedCountries.length > 0) {
          for (const country of this.selectedCountries) {
            this.countries.push(country);
          }
          this.countries = this.countries.map(item => ({
            ...item,
            checked: false
          }));
        }
        if (this.selectedCountries.length === 0) {
          this.isHiddenCountries = true;
          this.countries = this.countriesCopy;
        }
      }
      this.siteIds = this.selectedSiteIds.toString();

      this.countries = this.countries.sort((c1, c2) => {
        const cI = c1.countryName.toLowerCase();

        const cII = c2.countryName.toLowerCase();
        if (cI < cII) {
          return -1;
        }
        if (cI > cII) {
          return 1;
        }
        return 0;
      });
      const isSiteSame = this.sites.length && this.sites.every(this.isSameAnswer);
      this.AllSelectedSites = this.sites.length && this.sites.every(element => element.checked === true) && isSiteSame;
    },
    onSelectCountry(country, checked) {
      if (checked) {
        this.selectedCountryIds.push(country.countryId);
        this.selectedCountryList.push(country);
      } else {
        const index = this.selectedCountryIds.findIndex(item => item === country.countryId);
        this.selectedCountryIds.splice(index, 1);
      }
      this.countryIds = this.selectedCountryIds.toString();
    },
    SelectAllsites() {
      this.selectedSiteList = [];
      if (this.AllSelectedSites === false) {
        this.sites.filter(sdata => {
          sdata.checked = true;
        });
        this.selectedSiteList = this.sites;
        this.selectedSiteIds = this.sites.map(item => item.siteId);
        this.AllSelectedSites = true;
      } else {
        this.AllSelectedSites = false;
        this.selectedSiteIds = [];
        this.sites.filter(sdata => {
          sdata.checked = false;
        });
      }
    },
    getAllParticipants() {
      nprogress.start();
      const countries = [];
      for (const c of this.countries) {
        if (c.checked) {
          countries.push(c.countryId);
        }
      }
      const countryIds = countries.toString();
      const siteIds = this.selectedSiteIds.toString();
      this.$api
        .getParticipantsListFact(
          this.studyId,
          this.recordsPerPage,
          this.currentPage,
          "", //search
          "", //filter
          "userDefinedParticipantId",
          "asc",
          "", //customKey
          "",
          "", //cohortFilter
          "", //siteDocumentId
          "", //languageId
          "", //activateForMoreParticipants
          "",
          false,
          false,
          siteIds,
          countryIds
        )
        .then(
          response => {
            nprogress.done();
            this.allParticipants = response.body.participants;
            this.totalPages = response.body.totalPages;
            this.$refs["allParticipantModal"].show();
          },
          error => {
            nprogress.done();
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participants.");
          }
        );
    },
    prevPage() {
      if (this.currentPage <= this.totalPages) {
        this.currentPage -= 1;
        this.getAllParticipants();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1;
        this.getAllParticipants();
      }
    },
    exportSelectedData() {
      this.isSubFolderChecked = true;
      if (this.sites.length === 1) {
        this.selectedSiteList = this.sites;
      }

      // if(this.countries.length === 1){
      //     this.selectedCountryList = this.countries
      // }

      const countries = [];
      for (const c of this.countries) {
        if (c.checked) {
          countries.push(c.countryId);
        }
      }

      const checkFolder = this.folders.filter(item => item.checked);
      let folders = [];

      if (!this.isHiddenDate) {
        const startDate = new Date(this.startDate);
        const endDate = new Date(this.endDate);
        if (startDate > endDate) {
          this.$toastr.error("End date should be greater then start date.");
          return;
        }
      }

      if (!this.isHiddenFolder) {
        if (checkFolder.length === 0) {
          if (this.complianceReportData) {
            toastr.error("Selecting at least one activity is required.");
          } else {
            toastr.error("Selecting at least one folder is required.");
          }
          return;
        }
      } else {
        folders = this.folders;
      }

      if (!this.isHiddenSites) {
        if (this.selectedSiteIds.length === 0) {
          toastr.error("Selecting at least one site is required.");
          return;
        }
      }

      if (!this.isHiddenCountries) {
        if (countries.length === 0) {
          toastr.error("Selecting at least one country is required.");
          return;
        }
      }

      if (!this.isHiddenParticipants) {
        if (this.filteredSelectedParticipants.length === 0) {
          toastr.error("Selecting at least one participant is required.");
          return;
        }
      }

      const payload = {};
      const filters = {
        timeFrame: {
          startDate: "",
          endDate: ""
        },
        folders: [],
        sites: [],
        countries: [],
        participants: []
      };
      const startDate = this.startDate !== "" ? moment(this.startDate).format("YYYY-MM-DD") : "";
      const endDate = this.endDate !== "" ? moment(this.endDate).format("YYYY-MM-DD") : "";
      filters.timeFrame.startDate = startDate;
      filters.timeFrame.endDate = endDate;

      if (!this.isHiddenFolder) {
        const subFolderSelected = [];
        this.folders.forEach(item => {
          if (item.checked) {
            const fol = {
              subFolders: []
            };
            fol.folderName = item.folderName;
            fol.folderType = item.folderType;
            if (item.subFolders && item.subFolders.length > 0) {
              let checkCount = 0;
              item.subFolders.forEach(x => {
                if (x.checked) {
                  checkCount += 1;
                  const subFol = {};
                  subFol.subFolderName = x.subFolderName;
                  subFol.subFolderId = x.subFolderId;
                  fol.subFolders.push(subFol);
                }
              });
              subFolderSelected.push(!!checkCount);
            }
            folders.push(fol);
          }
        });
        const checkEmptySubFolders = subFolderSelected.indexOf(false);
        this.isSubFolderChecked = checkEmptySubFolders === -1;
      }

      const participants = [];

      this.filteredSelectedParticipants.forEach(item => {
        const participant = {};
        participant.participantId = item.id;
        participant.userdefinedParticipantId = item.userDefinedParticipantId;
        participants.push(participant);
      });

      filters.folders = folders;
      filters.sites = this.selectedSiteList;
      filters.countries = this.selectedCountryList;
      filters.participants = participants;
      payload.filters = filters;
      payload.pipeDelimited = this.pipeDelimitedSelectedData;
      this.filteredSelectedParticipants = [];
      this.selectedParticipantsInModal = [];
      this.searchParticipant = [];
      this.participantsList = [];

      const self = this;
      const user = localStorageService.getItem("userObj");
      self.siteId = user.siteIds;

      if (!this.isSubFolderChecked) {
        if (this.complianceReportData) {
          toastr.error("Selecting at least one activity is required.");
        } else {
          toastr.error("Selecting at least one folder is required.");
        }
        return;
      }

      if (this.complianceReportData) {
        this.$api.saveComplianceDataExportFilters(this.studyId, payload).then(
          () => {
            toastr.success("The Compliance Report is being generated for your study. You will receive an email with a download link once complete.");
            this.resetFilter();
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting study data export.");
          }
        );
      } else {
        this.$api.saveStudyDataExportFilters(this.studyId, payload).then(
          () => {
            toastr.success("Your data export is being generated. Please check your email for your access link.");
            this.resetFilter();
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting study data export.");
          }
        );
      }
    },
    onSelectFolder(folder) {
      if (!folder.checked) {
        folder.isOpen = false;
        if (folder.subFolders && folder.subFolders.length > 0) {
          folder.subFolders.forEach(item => {
            item.checked = false;
          });
          this.$forceUpdate();
        }
      } else {
        if (folder.subFolders && folder.subFolders.length > 0) {
          folder.subFolders.forEach(item => {
            item.checked = false;
          });
          this.$forceUpdate();
        }
      }
    },
    onSelectSubFolder(checked, folder) {
      if (!checked) {
        let subf;
        if (folder.subFolders && folder.subFolders.length > 0) {
          subf = folder.subFolders.filter(item => item.checked);
        }
        if (subf.length === 0) {
          folder.checked = false;
          folder.isOpen = false;
        }
      }
    },
    onParticipantSearch() {
      const siteIds = this.selectedSiteIds.toString();
      nprogress.start();
      this.$api
        .getParticipantsListFact(
          this.studyId,
          "",
          "",
          this.searchParticipant,
          "", //filter
          "", //sortValue
          "", //sortOrder
          "", //customKey
          "",
          "", //cohortFilter
          "", //siteDocumentId
          "", //languageId
          "", //activateForMoreParticipants
          "",
          false,
          false,
          siteIds,
          this.countryIds
        )
        .then(
          response => {
            nprogress.done();
            if (response.body.participants.length == 0) {
              toastr.error("No participant found.");
              return;
            }

            //NOW PUSH THIS SEARCHED RECORDS IN filteredSelectedParticipants BY WHICH OUR SERACHED RECORDS WILL SHOWN IN SELECTED/CHECKED MODE IN LIST
            this.filteredSelectedParticipants = _.unionBy(response.body.participants, this.filteredSelectedParticipants, "id");
            // PUSH THE SEARCHED RECORDS IN THE MAIN participantsList ARRAY
            this.participantsList = _.unionBy(this.participantsList, response.body.participants, "id");
          },
          error => {
            nprogress.done();
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participants.");
          }
        );
    },
    resetFilter() {
      this.startDate = "";
      this.endDate = "";
      this.folders = [];
      this.selectedParticipants = [];
      this.filteredSelectedParticipants = [];
      this.allParticipants = [];
      this.searchParticipant = [];
      this.selectedCountryIds = [];
      this.selectedSiteIds = [];
      this.countries = [];
      this.siteIds = [];
      this.selectedCountryList = [];
      this.sites = [];
      this.selectedSiteList = [];
      this.isHiddenDate = true;
      this.isHiddenFolder = true;
      this.isHiddenSites = true;
      this.isHiddenCountries = true;
      this.isHiddenParticipants = true;
      this.selectedCountries = [];
      this.participantsList = [];
      this.selectedParticipantsInModal = [];
      this.getStudyDataExportFilters();
    },
    goToPage(page) {
      this.currentPage = page;
      this.getAllParticipants();
    },
    toggleFolder(isHiddenFolder) {
      if (!isHiddenFolder) {
        this.folders = this.folders.map(item => ({
          ...item,
          checked: false,
          isOpen: false
        }));

        this.folders.forEach(item => {
          if (item.subFolders && item.subFolders.length > 0) {
            item.subFolders.forEach(x => {
              x["checked"] = false;
            });
          }
        });
      }
    },
    toggleSites() {
      if (!this.isHiddenSites) {
        this.sites = this.sites.map(item => ({ ...item, checked: false }));
      } else {
        this.countries = this.countriesCopy.map(item => ({
          ...item,
          checked: false
        }));
        this.selectedSiteIds = [];
        this.selectedSiteList = [];
      }
    },
    toggleDate(isHiddenDate) {
      if (!isHiddenDate) {
        this.startDate = "";
        this.endDate = "";
      }
    },
    toggleCountry(isHiddenCountries) {
      if (!isHiddenCountries) {
        this.countries = this.countries.map(item => ({
          ...item,
          checked: false
        }));
      } else {
        this.countries = this.countriesCopy.map(item => ({
          ...item,
          checked: true
        }));
      }
    },
    toggleParticipant(isHiddenParticipants) {
      if (!isHiddenParticipants) {
        this.selectedParticipants = [];
        this.filteredSelectedParticipants = [];
        this.searchParticipant = [];
        this.participantsList = [];
      }
    },
    closeModal() {
      const selectedParticipantList = this.allParticipants.filter(item => item.checked);
      for (const p of selectedParticipantList) {
        const found = this.participantsList.some(item => item.id == p.id);
        if (!found) {
          this.participantsList.push(p);
        }
      }
      this.currentPage = 1;
      this.$refs["allParticipantModal"].hide();
      this.onParticipantSelection();
    },
    selectedParticipantCount() {
      return this.participantsList.filter(item => item.checked).length;
    },
    onChangeEndDate() {
      this.$nextTick(() => {
        const startDate = new Date(this.startDate);
        const endDate = new Date(this.endDate);
        if (startDate > endDate) {
          this.$toastr.error("End date should be greater then start date.");
        }
      });
    },
    isSameAnswer(el, index, arr) {
      // Return true for the first element
      if (index === 0) {
        return true;
      } else {
        // Compare the value of the previous element
        return el.checked === arr[index - 1].checked;
      }
    }
  }
};
</script>

<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style lang="scss" src="@/assets/export-data-report.scss"></style
><style lang="scss">
#data-export-filter-container {
  .timeframe-dates {
    .vdp-datepicker {
      .vdp-datepicker__calendar-button {
        position: absolute;
        right: 9px;
        top: 7px;
        pointer-events: none;

        .fa-calendar-o {
          font: normal normal normal 14px/1 FontAwesome;
          pointer-events: none;
          color: #2291e1;
        }
      }

      .vdp-datepicker__calendar {
        right: 0;
      }
    }
  }
  .disable_ele {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
  }
  .reset_btn {
    padding: 6px 9px 6px 9px;
    border-radius: 3px;
    border: solid 2px #d3dfe4;
    font-family: Roboto-Regular;
    font-size: 12px;
    color: #4c8ce4;
    cursor: pointer;
  }
  .reset_btn_disabled {
    opacity: 0;
    cursor: context-menu;
  }
}
.pt-150 {
  padding: 70px 109px 70px 266px !important;
  color: #666669;
  opacity: 0.7;
}
.btn-pad-fix {
  padding: 0.375rem 0.75rem !important;
}
.back-container {
  span,
  a {
    cursor: pointer;
  }
}
.delimited-checkbox {
  .custom-control-label::before {
    top: 0px;
    width: 20px;
    height: 20px;
  }
  .custom-control-label::after {
    top: 0px;
    width: 20px;
    height: 20px;
  }
}
.colMarginCss {
  margin-bottom: 10px;
  label {
    margin-bottom: 0px;
  }
}
</style>
